import { useStore } from 'zustand';
import { useStoreContext } from './provider';
/**
 * Hook to access the global store state (web platform)
 */
export function useGlobalStore(selector) {
    const store = useStoreContext();
    return useStore(store, selector);
}
